import { Permission, type ParentEnvironmentResource } from "@octopusdeploy/octopus-server-client";
import { Form, useForm } from "~/components/form/Form/Form";
import type { EditParentEnvironmentWorkflowInput } from "~/workflows/EditParentEnvironmentWorkflowInput";
import { WorkflowContent } from "~/workflows/WorkflowContent";
import { workflows } from "~/workflows/workflows";
import { ParentEnvironmentForm } from "./ParentEnvironmentForm";
interface EditParentEnvironmentWorkflowProps {
    workflowInput: EditParentEnvironmentWorkflowInput;
    completeWorkflow: (output: ParentEnvironmentResource) => void;
}
export function EditParentEnvironmentWorkflow({ workflowInput: { parentEnvironment }, completeWorkflow }: EditParentEnvironmentWorkflowProps) {
    const { model, setModel, formProps, createSaveAction, getFieldError } = useForm({
        formName: "Parent Environment Drawer",
        initialModel: parentEnvironment,
        onSubmit: async (repository, model) => await repository.ParentEnvironments.modify(model),
        updateFormModelAfterSubmit: (model) => model,
        submitPermission: {
            permission: Permission.EnvironmentEdit,
            environment: parentEnvironment.Id,
        },
        afterSubmit: async (_, updatedModel) => {
            completeWorkflow(updatedModel);
        },
    });
    return (<WorkflowContent.Drawer workflow={workflows.editParentEnvironmentWorkflow} primaryAction={createSaveAction({ accessibleName: "Confirm Edit Parent Environment" })} title={model.Name}>
            <Form {...formProps}>
                <ParentEnvironmentForm model={model} setModel={setModel} getFieldError={getFieldError}/>
            </Form>
        </WorkflowContent.Drawer>);
}
